import { useEffect } from "react";
import styles from "./Alert.module.scss";

type Props = {
    title?: string;
    message: string;
    onClose?: () => void;
    duration?: number;
    type?: "success" | "error" | "warning" | "info";
};

const Alert: React.FC<Props> = ({ title, message, onClose, duration = 3000, type = "error" }) => {
    useEffect(() => {
        const timeout = setTimeout(onClose, duration);
        return () => clearTimeout(timeout);
    }, [onClose, duration]);

    const alertClass = `${styles.alert} ${type ? styles[type] : ""}`;

    return (
        <div className={alertClass}>
            {title && (
                <div className="d-flex align-items-center justify-content-center">
                    <p className={`text-center ${styles.title}`}>{title}</p>
                </div>
            )}
            <p dangerouslySetInnerHTML={{ __html: message }} className="text-center mb-0" />
        </div>
    );
};

export default Alert;
